<section>
    <xm-nav-menu-item *ngFor="let menuItem of pageData" [pageData]="menuItem" [myAccountChildItems]="true"></xm-nav-menu-item>
</section>
